import * as React from 'react';

const OrderedListSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="ordered-list_svg__eds-icon--ordered-list_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <g
            id="ordered-list_svg__eds-icon--ordered-list_numbers"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
        >
            <path d="M4 15.8h1.5l-.7.7.7.7H4v.8h3v-.8l-.8-.7.8-.7V15H4zM4 10.9h1.3l-1.3.8V13h3v-.9H5l2-1.2V10H4zM6 7V4H5L4 5.5h1V7H4v1h3V7z" />
        </g>
        <g
            id="ordered-list_svg__eds-icon--ordered-list_lines"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
        >
            <path d="M10 17h10v1H10zM10 12h10v1H10zM10 7h10v1H10z" />
        </g>
    </svg>
);

OrderedListSvg.displayName = 'OrderedListSvg';
export default OrderedListSvg;
